import { Text, VSpacing } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import numberFormatter from 'bloko/common/numberFormatter';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

import TitleWrapper from 'src/components/Search/Resume/Header/Title/Wrapper';

const TrlKeys = {
    found: 'employer.resumesSearch.found',
    resumes: 'employer.resumesSearch.resumes',
};

const ResumeSearchCatalogTitle: TranslatedComponent = ({ trls }) => {
    const text = useSelector((state) => state.pageMetaData.header);
    const isAnonymous = useSelector((state) => state.userType) === UserType.Anonymous;
    const resumesCount = useSelector((state) => state.resumeSearchResult.stats.totalUngroupedResults);

    return (
        <>
            <TitleWrapper>{text}</TitleWrapper>
            {!isAnonymous && (
                <>
                    <VSpacing default={8} />
                    <Text typography="label-2-regular" data-qa="resumes-total-found">
                        {trls[TrlKeys.found]}
                        {numberFormatter.format(`${resumesCount}`, { groupSeparator: NON_BREAKING_SPACE })}
                        {trls[TrlKeys.resumes]}
                    </Text>
                </>
            )}
        </>
    );
};

export default translation(ResumeSearchCatalogTitle);
